import { EnvironmentProviders, inject, InjectionToken, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';

import { provide, ProviderTypes } from '@kros-sk/core/di';

import { HttpMockService } from './http-mock.types';
import { HttpMockManagerService } from './http-mock-manager.service';

export function provideHttpMock(...mockProviders: Array<ProviderTypes<HttpMockService>>): EnvironmentProviders {
  return makeEnvironmentProviders(mockProviders.map((p) => make(p)));
}

function make(mockProvider: ProviderTypes<HttpMockService>): EnvironmentProviders {
  const tempToken = new InjectionToken<HttpMockService>('HttpMockService');

  return makeEnvironmentProviders([
    provide(tempToken, mockProvider),
    provideEnvironmentInitializer(() => {
      const manager = inject(HttpMockManagerService);
      const service = inject(tempToken);

      manager.register(service);
    }),
  ]);
}
